<template>
    <div class="container-fluid px-0">

        <AuthNav></AuthNav>

        <NavButtons light-btns></NavButtons>

    </div>
    <div class="row">
        <div class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4 mb-3">
            <div class="d-flex flex-column gap-3 text-center mb-5">
                <h3 class="fw-semi-bold m-0">Logging Out</h3>
                <p class="text-secondary m-0">Destroying session and logging you out of the application ...</p>
            </div>            
        </div>

    </div>

</template>

<script setup>
import { onMounted, ref } from "vue";
import { useAuthStore } from "@/stores/auth-store";
import { useAppHelpers } from '@/composables/useAppHelpers';
import NavButtons from "@/components/NavButtons.vue";
import AuthNav from "@/views/Auth/AuthNav.vue";

const helper = useAppHelpers();
const auth = useAuthStore();

onMounted(() => {
    setTimeout(() => {
        auth.processLogout();
    }, 800);
});

</script>

<style scoped lang="scss"></style>